import { StoryObject } from "@interfaces/properties.interface";
import React from "react";

type Props = {
  item: [string, StoryObject[]];
  setDes: (value: string) => void;
  calculateStory: () => void;
  originRef: React.MutableRefObject<HTMLInputElement | null>;
};

const SINGULAR_LABELS: Record<string, string> = {
  city: "City",
  state: "State",
  country: "Country",
  apartment: "Apartment",
  formatted_address: "Address",
  geo: "Location",
  locality: "Locality",
  political: "Political",
  neighborhood: "Neighborhood",
  route: "Route",
  street_address: "Street Address",
};

const capitalize = (value: string) =>
  value.replace(/\b\w/g, (char) => char.toUpperCase());

const pluralizeWord = (word: string) => {
  if (word.endsWith("s")) return word;
  if (word.endsWith("y") && !/[aeiou]y$/i.test(word)) {
    return `${word.slice(0, -1)}ies`;
  }
  return `${word}s`;
};

const formatNeighbourhoodLabel = (key: string) => {
  const normalized = key.toLowerCase();

  if (SINGULAR_LABELS[normalized]) {
    return SINGULAR_LABELS[normalized];
  }

  const words = key.replace(/_/g, " ").toLowerCase().split(" ");
  const lastIndex = words.length - 1;
  words[lastIndex] = pluralizeWord(words[lastIndex]);

  return capitalize(words.join(" "));
};

const getStoryCoordinates = (
  geometryLocation?: {
    lat?: number | (() => number);
    lng?: number | (() => number);
    location?: {
      lat?: number | (() => number);
      lng?: number | (() => number);
    };
  } | null,
) => {
  if (!geometryLocation) return null;

  const location = geometryLocation.location ?? geometryLocation;
  const lat =
    typeof location?.lat === "function" ? location.lat() : location?.lat;
  const lng =
    typeof location?.lng === "function" ? location.lng() : location?.lng;

  if (lat == null || lng == null) return null;

  return { lat, lng };
};

const formatStoryValue = (value: unknown) => {
  if (value == null || value === "") return null;
  if (Array.isArray(value)) return value.join(", ");
  if (typeof value === "object") return null;
  return String(value);
};

const NeighbourStory = ({
  item,
  setDes,
  calculateStory,
  originRef,
}: Props) => {
  const plainValue = Array.isArray(item[1]) ? null : formatStoryValue(item[1]);

  return (
    <div className="col-12 mt-3">
      <div className=" fw-bold ">{formatNeighbourhoodLabel(item[0])}</div>

      <div className="col-12">
        <div>
          {Array.isArray(item[1]) ? (
            item[1].map((i: any, index: number) => {
              const coords = getStoryCoordinates(i?.geometry?.location);
              if (!coords) return null;

              return (
                <div
                  className="row d-flex align-items-center col-auto  px-3 py-3 bg-white border-0 rounded-4 gap-2 mt-3 cursor-pointer story-card shadow-sm"
                  onClick={() => {
                    setDes(`${coords.lat}, ${coords.lng}`);
                    if (originRef.current) {
                      originRef.current.value = i.name || "";
                    }
                    calculateStory();
                  }}
                  key={(i.place_id || i.name || index) + index}
                >
                  <div className=" col-1 p-0 p-md-2 mr-2">
                    <img
                      src={i.icon}
                      alt={i.name}
                      height={40}
                      width={40}
                    />
                  </div>
                  <div className="col-9 ">
                    <p className="fs-14 fw-bold mb-0   text-capitalize">
                      {i.name}
                    </p>
                  </div>
                </div>
              );
            })
          ) : (
            plainValue && <p className="fs-14 mb-0 mt-3">{plainValue}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default NeighbourStory;
